// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"button-module--button-wrapper--1U0H-","button":"button-module--button--1WU8w","standalone":"button-module--standalone--1aPpr"};